var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_vm._l((_vm.clms),function(i){return [_c('v-col',{key:i+'1',staticClass:"py-0",attrs:{"cols":_vm.wdh}},[_c('v-skeleton-loader',{attrs:{"type":`list-item-avatar, list-item-${_vm.lines}-line,divider`}})],1),_c('v-col',{key:i+'2',attrs:{"cols":"1"}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }